import { gql } from '../../types/generated';

export const CREATE_SESSION_OVERRIDE = gql(`
  mutation createSessionOverride($features: [SessionFeature!]!, $matchParams: JSON!) {
    createSessionOverride(experience: MLB, features: $features, matchParams: $matchParams)
  }
`);

export const UPDATE_SESSION_OVERRIDE = gql(`
  mutation updateSessionOverride(
    $id: Int!
    $features: [SessionFeature!]!
    $matchParams: JSON!
  ) {
    updateSessionOverride(id: $id, experience: MLB, features: $features, matchParams: $matchParams)
  }
`);

export const DELETE_SESSION_OVERRIDE = gql(`
  mutation deleteSessionOverride($overrideId: Int!) {
    deleteSessionOverride(overrideId: $overrideId)
  }
`);
